export default [
    {
      path: '/smartPic/PicList',
      name: 'picList',
      component: () => import('@/views/smartPic/PicList'),
      meta: { title: 'menu.picList', keepAlive: true, permission: ['table'] },
    },
    {
      path: '/smartPic/ReplaceCloth',
      name: 'replaceCloth',
      component: () => import('@/views/smartPic/ReplaceCloth'),
      meta: { title: 'menu.replaceCloth', keepAlive: true, permission: ['form'] },
    },
    {
      path: '/smartPic/ReplaceBackdrop',
      name: 'replaceBackdrop',
      component: () => import('@/views/smartPic/ReplaceBackdrop'),
      meta: { title: 'menu.replaceBackdrop', keepAlive: true, permission: ['form'] },
    },
  ]